<template>
  <div>
    <button
      style="display: none"
      type="button"
      :class="triggerClass"
      data-bs-toggle="modal"
      :data-bs-target="`#${modalId}`"
    ></button>
    <div
      class="modal fade"
      :id="modalId"
      tabindex="-1"
      :aria-labelledby="`${modalId}Label`"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body d-flex justify-content-center">
            {{ message }}
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              data-bs-dismiss="modal"
              @click="$emit('ok')"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "xero-error-modal",
  props: {
    modalId: {
      type: String,
      default: "modalXeroError",
    },
    triggerClass: {
      type: String,
      default: "show-modal-xero-error",
    },
    title: {
      type: String,
      default: "Error",
    },
    message: {
      type: String,
      default: "Submitted failed. Please check the log.",
    },
  },
};
</script>


